import { isAppAllowlisted } from './allowlist';
import { logger } from 'src/commons/utils/logger';
import {
  ENABLE_LEGACY_REDIRECT_KEY,
  syncUpdateParamsFromUrlToStorage,
} from './urlUpdateUtils';

/**
 * Determines whether link updating should be applied.
 * Both conditions must be true:
 * 1. The current application is in the allowlist
 * 2. enableLegacyConversionMetrics is set to 'true' in session storage
 *
 * Before checking session storage, syncs any legacy metrics params present in the
 * current page URL into session storage. This ensures params carried over from
 * a region switch are available on the first render.
 */
export const shouldUpdateLinks = (appName: string): boolean => {
  if (!isAppAllowlisted(appName)) return false;

  try {
    // Ensure params from the URL (e.g. after a region switch) are persisted
    // to session storage before we check. Idempotent — only writes if needed.
    syncUpdateParamsFromUrlToStorage();

    if (window.sessionStorage.getItem(ENABLE_LEGACY_REDIRECT_KEY) !== 'true') {
      return false;
    }

    logger.info(`linkUpdater: URL updating enabled for ${appName}`);
    return true;
  } catch (e: any) {
    logger.warn(
      'linkUpdater: failed to read sessionStorage in shouldUpdateLinks',
      e,
    );
    return false;
  }
};
